import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";
import TitansNavbar from "../Components/TitansNavbar";
import TitansHero from "../Components/TitansHero";

function TitansEducation() {
  return (
    <>
      <Navbar2 />
      <TitansHero />
        <TitansNavbar />
        {/* Education */}
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <div className='titansTitle text-center pt-5 pb-3'>
              EDUCATION
            </div>
            </div>
          </div>
          <div className="row ps-lg-5">
            <div className="col-12 col-lg-6 lead">
              <p>
                At ADS Prep Academy, we recognize that every student-athlete
                has their own journey — and their education should be tailored to 
                match that journey.
              </p>
              <p>Through our partnership with AESA Prep Academy, a trusted institution
                with over 16 years of experience supporting student-athletes,
                each ADS athlete receives a flexible, NCAA-approved academic
                curriculum designed to fit their schedule, goals, and pace
                — empowering them to thrive academically while training and
                competing at elite levels.
              </p>
              <p>
                ADS students learn in a supportive classroom environment that
                pushes them to grow academically while receiving the attention and guidance they need to stay on track.
              </p>
              </div>
              <div className="col-12 col-lg-6 pt-sm-3 text-center">
                <img src="/s3/aesa_prep.png" 
                  alt=""
                width={554/2}
                height={550/2}
                />
              </div>
          </div>
        </div>
        {/* High School Academics */}
        <div className="container-fluid">
            <div className='titansTitle text-center pt-5 pb-3'>
              High School Academics
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 pb-5">
                <div className="container py-2">
                  <div className="card shadow-sm">
                    <div className="card-body">
                      <h5 className="card-title mb-3">Graduation Requirements</h5>
                      <div className="table-responsive">
                        <table className="table table-sm table-striped table-hover align-middle mb-0">
                          <caption className="text-muted">Credit requirements by subject area.</caption>
                          <thead className="table-dark">
                            <tr>
                              <th scope="col">Subject</th>
                              <th scope="col" className="text-center">Credits</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr><td>Math</td><td className="text-center">4</td></tr>
                            <tr><td>English</td><td className="text-center">4</td></tr>
                            <tr><td>Social Studies</td><td className="text-center">4</td></tr>
                            <tr><td>Science</td><td className="text-center">4</td></tr>
                            <tr><td>Global Language</td><td className="text-center">4</td></tr>
                            <tr><td>Health</td><td className="text-center">1</td></tr>
                            <tr><td>Physical Education</td><td className="text-center">1</td></tr>
                            <tr><td>Communication</td><td className="text-center">1</td></tr>
                            <tr><td>Fine Art</td><td className="text-center">1</td></tr>
                            <tr><td>Technology</td><td className="text-center">1</td></tr>
                            <tr><td>Additional Electives</td><td className="text-center">3</td></tr>
                          </tbody>
                          <tfoot>
                            <tr className="fw-semibold">
                              <td className="text-end">Total</td>
                              <td className="text-center">28</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                <div className="col-12 col-lg-6 lead pe-lg-5">
                  AESA offers a comprehensive 4-year college preparatory high
                  school program that supports students competing at state
                  and national levels. Graduation requires a minimum of 26
                  credits, and the AESA diploma provides an advanced transcript
                  that positions students to apply to colleges and universities
                  of their choice.
                  {/* Inner table */}
                  <div className="card shadow-sm mt-3">
                    <div className="card-body">
                      <h5 className="card-title mb-3">Must Be Taken Before Graduation</h5>
                      <div className="table-responsive">
                        <table className="table table-sm table-striped table-hover align-middle mb-0">
                          <caption className="text-muted">Required courses prior to graduation</caption>
                          <thead className="table-dark">
                            <tr>
                              <th scope="col">Course</th>
                              <th scope="col" className="text-end">Credits</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr><td>Fine Art</td><td className="text-end">1</td></tr>
                            <tr><td>Physical Education</td><td className="text-end">1</td></tr>
                            <tr><td>Health</td><td className="text-end">1</td></tr>
                            <tr><td>Technology</td><td className="text-end">1</td></tr>
                          </tbody>
                          <tfoot>
                            <tr className="fw-semibold">
                              <td className="text-end">Total</td>
                              <td className="text-end">4</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div>
      <Footer />
    </>
);
}

export default TitansEducation;
